export const DEFAULT_DISPLAY_TIME_ZONE = 'UTC'

export const resolveTimeZone = (timeZone: Maybe<string>): Maybe<string> => {
  if (!timeZone) {
    return null
  }

  try {
    Intl.DateTimeFormat('en-US', { timeZone })

    return timeZone
  } catch {
    return null
  }
}
